
let log = function (...input) {
    if (process.env.environment !== 'production') {
        console.info(input);
    }
};

export default log;